// react
import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

// context
import { WorkspaceProvider } from "./common/context/WorkspaceContext";

// components
import LoadingScreen from "./common/components/LoadingScreen";

// pages
const MainWorkspace = lazy(() => import("./pages/Workspace"));
const NotFound = lazy(() => import("./pages/NotFound"));

// routes
const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <WorkspaceProvider>
                                <MainWorkspace />
                            </WorkspaceProvider>
                        </Suspense>
                    }
                />
                <Route
                    path="*"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <NotFound />
                        </Suspense>
                    }
                />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
